import axios from "axios";
import { getB2BTokens } from "../AuthService/userData";
import { axiosWithToken } from "../AuthService/AxiosToken";


const axiosMethod = (url, data, headers, method) => {
  switch (method) {
    case "post":
      return axiosWithToken.post(url, data, headers);

    case "put":
      return axiosWithToken.put(url, data, headers);

    case "delete":
      return axiosWithToken.delete(url, headers);

    default:
      return axiosWithToken.get(url, headers);
  }
}

function allTenantCall(url, headers, method, data) {
  const requests = getB2BTokens().map((tenant) => {
    headers.payername = tenant.payerName;
    headers["Authorization"] = "Bearer " + tenant.accessToken;
    if (url === "/claim/provider/redirect") headers.receiverId = tenant.providerUserInfo.id
    return axiosMethod(process.env.REACT_APP_BASE_URL_B2B + url, data, {
      headers: headers,
    }, method);
  });

  return axios
    .all(requests)
    .then(
      axios.spread((...responses) => {
        console.log(responses); // Concatenate the response data from each API call into a single array
        const responseData = responses.reduce((acc, response) => {
          return acc.concat(response.data);
        }, []); // Return the concatenated response data

        return responseData;
      })
    )
    .catch((error) => {
      // Handle errors here
      console.error(error);
      return Promise.reject(error);
    });
}

export default allTenantCall;
